import carDict from './dict/carDict'
import driverDict from './dict/driverDict'
import selectOptionDict from './dict/selectOptionDict'
import { CATEGORY_FEE_MAP } from './dict/rentPlanDict'

const getters = {
  allCities: (state) => state.global.allCities,
  rentMallOpenSwitch: (state) => state.global.rentMallOpenSwitch, // 租赁商城开关
  newCalculationOpenSwitch: (state) => state.global.newCalculationOpenSwitch, // 新版计租配置开关
  cityCodeMap: (state) => state.global.cityCodeMap,
  authInfo: (state) => state.global.authInfo,
  brandList: (state) => state.global.brandList, // 权限限制下的品牌列表
  smsConfig: (state) => state.global.smsConfig, // 短信推送云控返回时间信息
  phoneConfig: (state) => state.global.phoneConfig, // 语音推送云控返回时间信息
  sidebar: (state) => state.app.sidebar,
  cacheRouteList: (state) => state.app.cacheRouteList,
  quneWaitRefreshRoute: (state) => state.app.quneWaitRefreshRoute,
  userInfo: (state) => state.user.userInfo || {},
  token: (state) => state.user.token,
  permission_routers: (state) => state.permission.routers,
  ...carDict,
  ...driverDict,
  // 等待权限资源
  isGetPermission: (state) => state.permission.isGetPermission,
  // 资源树
  addRouters: (state) => state.permission.addRouters,
  allResource: (state) => state.permission.allResource,
  // 路由状态数据
  asynRouters: (state) => state.permission.asynRouters,
  // 平台权限
  pathnames: (state) => state.permission.pathnames,
  // logo
  logoText: (state) => state.permission.logoText,
  logo: (state) => state.permission.logo,
  menuList: (state) => state.permission.navMenus, // 左侧一级菜单栏目
  resourceList: (state) => state.permission.resourceList,
  subMenuList: (state) => state.permission.subMenuList, // 左侧二级菜单
  menus: (state) => state.permission.menus,
  breadcrumb: (state) => state.global.breadcrumb,
  device: (state) => state.app.device,
  // 二级菜单是否显示
  hoverMenuShow: (state) => state.app.hoverMenuShow,
  // 车辆状态枚举
  carStateList: (state) => state.global.carStateList,
  carWorkStateList: (state) => state.global.carWorkStateList,
  // 付款方式枚举
  paymentMethods: (state) => state.global.paymentMethods,
  // 扣款状态枚举
  accruedState: () => selectOptionDict.accruedState,
  // 审批类型
  approvalType: () => selectOptionDict.approvalType,
  // 审批状态
  approvalBizType: () => selectOptionDict.approvalBizType,
  // 审批内容
  approvalState: () => selectOptionDict.approvalState,
  // 审批来源
  approvalOrigin: () => selectOptionDict.approvalOrigin,
  // 获取header待办数量
  todoCount: (state) => state.global.todoCount,
  // 费项list(根据不同的类别显示不同的费项)
  feeList: (state) => state.rentPlan[CATEGORY_FEE_MAP[state.rentPlan.rentCategory]],
  // 获取银行清分渠道
  bankChannelType: (state) => state.global.bankChannelType,
  bankChannelName: (state) => state.global.bankChannelName,
  areaLinkageProvinceList: (state) => state.global.areaLinkageProvinceList,
}
export default getters
